import React from 'react';
import { LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { IconCtaSimplifiedCard } from '@ahc-digital/component-library';
import { CreateIconCTASimplifiedCard } from './C30IconCTASimplified.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C30IconCTASimplifiedCardProps = RenderingProps<
  C30IconCTASimplifiedCardFields,
  {
    CTAStyle?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;

export type C30IconCTASimplifiedCardFields = {
  Icon?: KeyValuePair;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
};

export const Default = (props?: C30IconCTASimplifiedCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaSimplifiedCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateIconCTASimplifiedCard(props)}
    />
  );
};
